export enum FACTURACION_TYPES {
  FORMCLIENTE_HANDLE_CHANGE = 'FORMCLIENTE_HANDLE_CHANGE',
  FORMCLIENTE_SET_ERRORS = 'FORMCLIENTE_SET_ERRORS',
  FORMPRODUCTOS_HANDLE_CHANGE = 'FORMPRODUCTOS_HANDLE_CHANGE',
  FORMPRODUCTOS_SET_ERRORS = 'FORMPRODUCTOS_SET_ERRORS',
  FORMPRODUCTOS_HANDLE_CHANGE_EDIT = 'FORMPRODUCTOS_HANDLE_CHANGE_EDIT',
  FORMPRODUCTOS_SET_ERRORS_EDIT = 'FORMPRODUCTOS_SET_ERRORS_EDIT',
  FORMSUCURSAL_HANDLE_CHANGE = 'FORMSUCURSAL_HANDLE_CHANGE',
  FORMSUCURSAL_SET_ERRORS = 'FORMSUCURSAL_SET_ERRORS',
  FORMPRODUCTOS_CLEAR = 'FORMPRODUCTOS_CLEAR',
  ARRAYPRODUCTOS_ADD = 'ARRAYPRODUCTOS_ADD',
  ARRAYPRODUCTOS_SET_DATA = 'ARRAYPRODUCTOS_SET_DATA',
  ARRAYPRODUCTOS_EDIT = 'ARRAYPRODUCTOS_EDIT',
  ARRAYPRODUCTOS_SET_CALCULOS = 'ARRAYPRODUCTOS_SET_CALCULOS',
  ARRAYPRODUCTOS_SET_TOTAL_DOC_RELACIONADO = 'ARRAYPRODUCTOS_SET_TOTAL_DOC_RELACIONADO',
  ARRAYPRODUCTOS_CLEAR_ALL = 'ARRAYPRODUCTOS_CLEAR_ALL',
  ARRAYPRODUCTOS_SELECT_ONE = 'ARRAYPRODUCTOS_SELECT_ONE',
  ARRAYPRODUCTOS_DELETE_ONE = 'ARRAYPRODUCTOS_DELETE_ONE',
  FACTURACION_CLEAR_ALL = 'FACTURACION_CLEAR_ALL',
  SET_DATOS_EMISOR = 'SET_DATOS_EMISOR',
  SET_DATOS_FACTURA = 'SET_DATOS_FACTURA',
  FACTURA_EMITIDA = 'FACTURA_EMITIDA',
  OPCIONES_ACTIVA = 'OPCIONES_ACTIVA',
  SET_CATALOGO_SUCURSAL = 'SET_CATALOGO_SUCURSAL',
  SET_CATALOGO_SERIE = 'SET_CATALOGO_SERIE',
  SET_UUID = 'SET_UUID',
  FACTURACION_ANULADO = 'FACTURACION_ANULADO',
  FACT_SETINFO_CLIENTE = "FACT_SETINFO_CLIENTE",
  FACT_DELETE_SERVICIOS = "FACT_DELETE_SERVICIOS",

  // MODALS
  MODALELIMINAR_OPEN = 'MODALELIMINAR_OPEN',
  MODALELIMINAR_CLOSE = 'MODALELIMINAR_CLOSE',
  MODALEDITAR_OPEN = 'MODALEDITAR_OPEN',
  MODALEDITAR_CLOSE = 'MODALEDITAR_CLOSE',
  MODALFACTURACION_OPEN = 'MODALFACTURACION_OPEN',
  MODALIMPRESION_OPEN = 'MODALIMPRESION_OPEN',
  MODALEMAIL_OPEN = 'MODALEMAIL_OPEN',
  MODALANULAR_OPEN = 'MODALANULAR_OPEN',
  MODALCONFIRMARCLIENTEVACIO = 'MODALCONFIRMARCLIENTEVACIO',
  MODAL_INFOCLIENTE_OPEN = 'MODAL_INFOCLIENTE_OPEN',
  MODAL_INFOCLIENTE_CLOSE = 'MODAL_INFOCLIENTE_CLOSE',
  MODAL_SET_INFOCLIENTE = 'MODAL_SET_INFOCLIENTE',
}
